import { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  // Memoise so navigate state keeps stable identity across re-renders
  const redirectState = useMemo(() => ({ from: location.pathname }), [location.pathname]);

  if (user === null) {
    return (
      <div className="min-h-screen bg-[var(--trj-navy)] flex items-center justify-center" data-testid="auth-loading">
        <Loader2 className="w-6 h-6 text-[var(--trj-gold)] animate-spin" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/admin/login" replace state={redirectState} />;
  }
  return children;
}
